import './index.css'
import Button from '../button'

function PricingModulePayment({price,interval,CTA,details }){
async function startCheckout(details) {
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/create-checkout-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: details.email,
        auth: details.auth,
      }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || "Failed to create checkout session");
    }

    const { url } = await res.json();
    window.location.assign(url);
  } catch (e) {
    console.error(e);
    alert("Something went wrong starting checkout.");
  }
}

    return     <div className="pricing-module">
      <div className="small-text highlight-green">{interval}</div>
      <h2 className="big-text">{price}</h2>

      <button
        type="button"
        className="button checkout-button small-text"
        onClick={() => startCheckout(details)}
        disabled={!details}
      >
        {CTA}
      </button>
    <div className='benefits-grid'>
        <div className='globule'></div>
        <div className='benefit small-text'>Up to 10 sites</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Unlimited social post ideas</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Content scheduler</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Download to word format</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Unlimited feed items</div>
    </div>
    </div>
}

export default PricingModulePayment